import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { CalendarStatus } from '@/services/api-providers/CalendarServiceProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarIntegrationBar',
  props: {
    status: null,
    email: { default: '' },
    lastSyncAt: { default: '' },
    isSyncing: { type: Boolean, default: false }
  },
  emits: ["connect", "disconnect", "reconnect", "sync"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'connect'): void;
  (e: 'disconnect'): void;
  (e: 'reconnect'): void;
  (e: 'sync'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { status: CalendarStatus['status'], email: string, lastSyncAt: string, isSyncing: boolean }





const expanded = ref(false);
const isConnecting = ref(false);
const isDisconnecting = ref(false);

const isDisconnected = computed(() => props.status === 'disconnected' || props.status === 'not_connected');

const isActionRequired = computed(() => props.status === 'action_required' || props.status === 'expired');

const resetConnecting = () => {
  isConnecting.value = false;
};

expose({ resetConnecting });

const handleConnect = () => {
  isConnecting.value = true;
  emit('connect');
};

const syncLabel = computed(() => {
  if (props.isSyncing) return 'Syncing\u2026';
  if (!props.lastSyncAt) return '';
  const syncDate = new Date(props.lastSyncAt);
  const nowMs = Date.now();
  const diffSec = Math.floor((nowMs - syncDate.getTime()) / 1000);
  if (diffSec < 60) return 'Synced just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `Synced ${diffMin} min ago`;
  const diffHr = Math.floor(diffMin / 60);
  return `Synced ${diffHr}h ago`;
});

return { __sfc: true,props, emit, expanded, isConnecting, isDisconnecting, isDisconnected, isActionRequired, resetConnecting, handleConnect, syncLabel }
}

})